// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__G6r2e","disappear":"Preloader_disappear__Hmgmj","animation_area":"Preloader_animation_area__eRbIR","move":"Preloader_move__OFQFe"};